export const CFG_ALGORITHM = "algorithm";

export const CFG_NWISE_N = "n";
export const CFG_NWISE_COVERAGE = "coverage";
export const CFG_NWISE_TUPLES = "tuples";

export const CFG_RND_LENGTH = "length";
export const CFG_RND_DUPLICATES = "duplicates";
export const CFG_RND_ADAPTIVE = "adaptive";

export const CFG_CONSTRAINTS = "constraints";
export const CFG_ASSIGNMENTS = "assignments";

export const CFG_HEADER = "header";
export const CFG_CHOICE_NAMES = "choice names";
export const CFG_SEPARATOR = "separator";

export const CFG_FILTERS = "filters";
export const CFG_FILTERS_TYPE = "type";
export const CFG_FILTERS_VALUE = "value";
export const CFG_FILTERS_TARGET = "target";

export const CFG_TUPLES = "tuplestocover";

export const VAL_TRUE = "True";
export const VAL_FALSE = "False";

export const VAL_ALG_NWISE = "n-wise";
export const VAL_ALG_RANDOM = "random";
export const VAL_ALG_CARTESIAN = "cartesian";

export const VAL_FILTER_BLACKLIST = "Blacklist";
export const VAL_FILTER_WHITELIST = "Whitelist";

export const VAL_FILTER_ALL = "All";
export const VAL_FILTER_PARAMETER = "Parameters";
export const VAL_FILTER_CHOICE = "Choices";
export const VAL_FILTER_CHILDREN = "Parameters and choices";
export const VAL_FILTER_CONSTRAINT = "Constraints";
export const VAL_FILTER_ASSIGNMENT = "Assignments";
export const VAL_FILTER_LOGIC = "Constraints and assignments";

export const VAL_CONSTRAINTS_NORMAL = "Process constraints normally";
export const VAL_CONSTRAINTS_IGNORE = "Ignore constraints";
export const VAL_CONSTRAINTS_NEGATE = "Negate constraints";
export const VAL_CONSTRAINTS_INVERT = "Invert constraints";

export const VAL_ASSIGNMENTS_NORMAL = "Process assignments normally";
export const VAL_ASSIGNMENTS_IGNORE = "Ignore assignments";
